import styled from 'styled-components';

export const DatatableActionsContainer = styled.div`
  display: flex;
  align-items: center;
  > .btn {
    padding-left: 8px;
  }
`;
